// import { createSlice } from "@reduxjs/toolkit";
// import {
//   createRespondentCounselAction,
//   updateRespondentCounselAction,
//   deleteRespondentCounselAction,
//   getRespondentCounselByCaseIDAction,
//   deleteRespondentCounselDocumentAction,
// } from "../../actions/RespondentCounsel/respondentCounselAction";

// const initialState = {
//   respondentCounselList: [],
//   loading: false,
//   error: null,
// };
// const respondentCounselSlice = createSlice({
//   name: "respondentCounsel",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(getRespondentCounselByCaseIDAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(getRespondentCounselByCaseIDAction.fulfilled, (state, action) => {
//         state.loading = false;
//         state.respondentCounselList = action.payload;
//       })
//       .addCase(getRespondentCounselByCaseIDAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(createRespondentCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createRespondentCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         state.respondentCounselList.push(action.payload);
//       })
//       .addCase(createRespondentCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(updateRespondentCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateRespondentCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.respondentCounselList.findIndex(
//           (item) => item.id === action.payload.id,
//         );
//         if (index !== -1) {
//           state.respondentCounselList[index] = action.payload;
//         }
//       })
//       .addCase(updateRespondentCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(deleteRespondentCounselAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteRespondentCounselAction.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.respondentCounselList.findIndex(
//           (item) => item.id === action.payload.id,
//         );
//         if (index !== -1) {
//           state.respondentCounselList.splice(index, 1);
//         }
//       })
//       .addCase(deleteRespondentCounselAction.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//     builder
//       .addCase(deleteRespondentCounselDocumentAction.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteRespondentCounselDocumentAction.fulfilled, (state) => {
//         state.loading = false;
//       })
//       .addCase(
//         deleteRespondentCounselDocumentAction.rejected,
//         (state, action) => {
//           state.loading = false;
//           state.error = action.payload;
//         },
//       );
//   },
// });

// export default respondentCounselSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";
import {
  createRespondentCounselAction,
  updateRespondentCounselAction,
  deleteRespondentCounselAction,
  getRespondentCounselByCaseIDAction,
  deleteRespondentCounselDocumentAction,
} from "../../actions/RespondentCounsel/respondentCounselAction";

// ============================================================================
// INITIAL STATE
// ============================================================================

const initialState = {
  counsels: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

// ============================================================================
// SLICE
// ============================================================================

const respondentCounselSlice = createSlice({
  name: "respondentCounsel",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    // =========================================================================
    // GET COUNSELS BY CASE ID
    // =========================================================================
    builder
      .addCase(getRespondentCounselByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getRespondentCounselByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.counsels = action.payload.data || [];
        },
      )
      .addCase(getRespondentCounselByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // CREATE COUNSEL
    // =========================================================================
    builder
      .addCase(createRespondentCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRespondentCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel created successfully";
        state.counsels.push(action.payload.data);
      })
      .addCase(createRespondentCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE COUNSEL
    // =========================================================================
    builder
      .addCase(updateRespondentCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRespondentCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel updated successfully";

        const index = state.counsels.findIndex(
          (c) =>
            c.respondentCounsel_ID === action.payload.data.respondentCounsel_ID,
        );

        if (index !== -1) {
          state.counsels[index] = action.payload.data;
        }
      })
      .addCase(updateRespondentCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL
    // =========================================================================
    builder
      .addCase(deleteRespondentCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRespondentCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Counsel deleted successfully";

        state.counsels = state.counsels.filter(
          (c) => c.respondentCounsel_ID !== action.payload,
        );
      })
      .addCase(deleteRespondentCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL DOCUMENT
    // =========================================================================
    builder
      .addCase(deleteRespondentCounselDocumentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRespondentCounselDocumentAction.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Document deleted successfully";
      })
      .addCase(
        deleteRespondentCounselDocumentAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearError, clearSuccess } = respondentCounselSlice.actions;
export default respondentCounselSlice.reducer;
